import { render } from "./Player.vue?vue&type=template&id=7f3d6326"
import script from "./Player.vue?vue&type=script&lang=ts"
export * from "./Player.vue?vue&type=script&lang=ts"
script.render = render

export default script